var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgRaindrop = function SvgRaindrop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 1024 1024"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M170.668 700.631C170.668 879.223 323.488 1024 512 1024s341.332-144.777 341.332-323.369C853.332 485.053 512 0 512 0S170.668 485.053 170.668 700.631zm85.332 0C256 554.659 512 153.6 512 153.6s256 401.068 256 547.031c0 152.701-152.82 238.028-256 238.028s-256-85.332-256-238.028z"
  })));
};
export default SvgRaindrop;